<template>
  <div class="g-page">
    <div class="user_box">
      <div class="user_item">
        <img class="logo" src="../assets/img/logo-small@3x.png" alt="墨计">
      </div>
    </div>
    <div class="vip_box">
      <div class="bg">
        <div class="inner">
          <div class="head">
            <div class="ttl">墨计服务VIP</div>
            <div class="status" v-if="!vipInfo.vipUser">未开启</div>
            <div class="status" v-else-if="vipInfo.vipExpired">已暂停</div>
            <div class="status" v-else>{{vipInfo.endDate | dateFormatter}}到期</div>
          </div>
          <div class="days">
            <span class="count" v-if="!vipInfo.vipUser">未开启</span>
            <template v-else>
              还剩 <span class="count">{{vipInfo.remainDays || 0}}</span> 天
            </template>
          </div>
        </div>
      </div>
      <div class="foot">
        <div class="col">
          <img class="icon" src="../assets/img/service-right@3x.png" alt="勾选">不限项目
        </div>
        <div class="col">
          <img class="icon" src="../assets/img/service-right@3x.png" alt="勾选">不限人数
        </div>
        <div class="col">
          <img class="icon" src="../assets/img/service-right@3x.png" alt="勾选">全年服务
        </div>
      </div>
    </div>
    <div class="buy_box">
      <template v-if="vipInfo.vipUser && !vipInfo.vipExpired">
        <div class="transfer_btn" @click="transfer">转让VIP</div>
        <div class="top-up_btn" @click="topup">续期</div>
      </template>
      <div
        class="buy_btn"
        v-else
        @click="topup"
      >
        <span class="n">￥{{vipPrice.salePrice || 0}}</span> 立即开启
      </div>
    </div>
    <div class="service_box">
      <div class="title">功能特权</div>
      <div class="list" style="padding-bottom: .25rem;">
        <div class="item">
          <img
            class="icon"
            src="../assets/img/service-content-attendance@3x.png"
            alt="考勤管理"
          >
          <div class="desc">考勤管理</div>
        </div>
        <div class="item">
          <img
            class="icon"
            src="../assets/img/service-content-time@3x.png"
            alt="工时统计"
          >
          <div class="desc">工时统计</div>
        </div>
        <div class="item">
          <img
            class="icon"
            src="../assets/img/service-content-money@3x.png"
            alt="工钱统计"
          >
          <div class="desc">工钱统计</div>
        </div>
      </div>
      <div class="list" style="margin-top: 0">
        <div class="item">
          <img
            class="icon"
            src="../assets/img/service-content-time-excel@3x.png"
            alt="考勤表导出"
          >
          <div class="desc">考勤表导出</div>
        </div>
        <div class="item">
          <img
            class="icon"
            src="../assets/img/service-content-money-excel@3x.png"
            alt="工资表导出"
          >
          <div class="desc">工资表导出</div>
        </div>
        <div class="item">
          <img
            class="icon"
            src="../assets/img/service-content-data@3x.png"
            alt="数据实时查看"
          >
          <div class="desc">数据实时查看</div>
        </div>
      </div>
    </div>
    <div class="service_box">
      <div class="title">服务特权</div>
      <div class="list">
        <div class="item">
          <img
            class="icon"
            :style="{height: '2.5rem'}"
            src="../assets/img/service-after-content-one@3x.png" alt="1对1指导">
          <div class="desc" :style="{marginTop: '.25rem'}">1对1指导</div>
        </div>
        <div class="item">
          <img
            class="icon"
            :style="{height: '2.5rem'}"
            src="../assets/img/service-after-content-service@3x.png" alt="专属客服">
          <div class="desc" :style="{marginTop: '.25rem'}">专属客服</div>
        </div>
        <div class="item">
          <img
            class="icon"
            :style="{height: '2.5rem'}"
            src="../assets/img/service-after-content-support@3x.png" alt="技术支持">
          <div class="desc" :style="{marginTop: '.25rem'}">技术支持</div>
        </div>
      </div>
    </div>
    <div class="other_service_box">
      <div class="title">其他特权</div>
      <div class="list span2">
        <div class="item">
          <img class="icon" src="../assets/img/service-other-content-contact@3x.png" alt="私有工友库">
          <div class="desc">私有工友库</div>
        </div>
        <div class="item">
          <img class="icon" src="../assets/img/service-other-content-update@3x.png" alt="免费升级">
          <div class="desc">免费升级</div>
        </div>
      </div>
    </div>
    <div class="call_box">
      <div class="list">
        <a class="call_item" :style="{marginBottom: '.8rem'}" href="tel:400-004-0686">
          <div class="info">
            <div class="ttl">客服电话</div>
            <div class="tel" href="tel:400-004-0686">400-004-0686</div>
          </div>
          <img class="icon" src="../assets/img/service-phone@3x.png" alt="拨打电话">
        </a>
        <a class="call_item" href="tel:400-004-0686">
          <div class="info">
            <div class="ttl">商务合作</div>
            <div class="tel" href="tel:400-004-0686">400-004-0686</div>
          </div>
          <img class="icon" src="../assets/img/service-phone@3x.png" alt="拨打电话">
        </a>
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment';
import req from '../req';

export default {
  data() {
    return {
      user: {},
      vipInfo: {},
      vipPrice: {},
    };
  },
  name: 'service',
  filters: {
    dateFormatter(value) {
      if (!value) return '';
      return moment(value).format('YYYY-MM-DD');
    },
  },
  mounted() {
    // this.getMyInfo();
    this.getVipPrice();
  },
  methods: {
    /**
     * 获取用户信息
     */
    getMyInfo() {
      const that = this;
      return req.user.getMyInfo()
        .then((res) => {
          if (res.code !== 0) {
            req.err.show(res.msg);
            return null;
          }
          that.user = res.data;
          return res.data;
        })
        .catch((err) => {
          req.err.show(err);
        });
    },
    /**
     * 获取vip价格
     */
    getVipPrice() {
      const that = this;
      req.sys.getVipPrice()
        .then((res) => {
          if (res.code !== 0) {
            req.err.show(res.msg);
            return null;
          }
          that.vipPrice = res.data;
          return res.data;
        })
        .catch((err) => {
          req.err.show(err);
        });
    },
    /**
     * 充值
     */
    topup() {
      this.$router.push({
        name: 'topup',
      });
      _hmt.push(['_trackEvent', '立即开启', '点击']);
    },
  },
};
</script>

<style lang="scss" scoped>
.g-page {
  background-color: #fff;
}

.user_box {
  height: 6.175rem;
  background-color: #212732;
  border-radius: 0 0 8% 8%;

  .user_item {
    display: flex;
    align-items: center;
    padding: 0 1.25rem .95rem;

    .logo {
      display: block;
      margin: 1rem auto;
      height: 1rem;
    }

    .avt {
      display: block;
      width: 2rem;
      height: 2rem;
      border-radius: 100%;
    }

    .info {
      margin-left: .5rem;
      color: #fff;
      font-size: .8rem;

      .worker_code {
        opacity: .8;
        line-height: 1.5;
        font-size: .7rem;
      }
    }
  }
}

.vip_box {
  width: 17.25rem;
  margin: -3.3rem auto 0 auto;
  border-radius: .4rem;
  background-color: #ecf3fb;

  .bg {
    border-radius: .4rem;
    background-image: linear-gradient(64deg, #5fc8fd, #726ef9);

    .inner {
      height: 6.55rem;
      background: url('../assets/img/service-card-bg@3x.png') no-repeat 12rem bottom;
      background-size: 3.85rem 4.6rem;

      .head {
        display: flex;
        justify-content: space-between;
        padding: .75rem 0 0 .8rem;

        .ttl {
          font-size: .9rem;
          font-weight: bold;
          color: #fff;
        }

        .status {
          border-radius: .625rem 0 0 .625rem;
          background-color: rgba(255, 255, 255, 0.2);
          font-size: .7rem;
          color: #fff;
          padding: .1rem .5rem;
        }
      }

      .days {
        margin-top: .5rem;
        text-align: center;
        color: #fff;
        font-size: .7rem;

        .count {
          font-size: 2rem;
          font-weight: bold;
        }
      }
    }
  }

  .foot {
    display: flex;
    justify-content: space-between;
    padding: .4rem 1.2rem .4rem;

    .col {
      display: flex;
      align-items: center;
      font-size: .6rem;
      color: #377fee;

      .icon {
        display: block;
        width: .6rem;
        height: .6rem;
        margin-right: .25rem;
      }
    }
  }
}

.buy_box {
  margin-top: 1rem;
  display: flex;
  justify-content: center;
  padding-bottom: 1rem;

  .buy_btn {
    width: 17.25rem;
    height: 2rem;
    line-height: 2rem;
    border-radius: .3rem;
    background-image: linear-gradient(to right, #fede87, #f3ca5d);
    color: #9d6904;
    text-align: center;
    font-size: .8rem;
    font-weight: bold;

    .n {
      font-size: 1rem;
      font-weight: bold;
    }
  }

  .transfer_btn {
    width: 8.25rem;
    height: 2rem;
    line-height: 2rem;
    border-radius: .3rem;
    border: solid 1px #c0c4cb;
    text-align: center;
    color: #535a64;
    font-size: .8rem;
    font-weight: bold;
  }

  .top-up_btn {
    width: 8.25rem;
    height: 2rem;
    line-height: 2rem;
    border-radius: .3rem;
    background-image: linear-gradient(to left, #e9d0a9, #d29e5b);
    text-align: center;
    color: #5f4824;
    font-size: .8rem;
    font-weight: bold;
    margin-left: .75rem;
  }
}

.service_box {
  background-color: #fff;
  border-top: .5rem solid #f7f7fa;

  .title {
    padding: .75rem 1rem 0;
    font-size: .8rem;
    color: #535a64;
  }

  .list {
    display: flex;
    margin-top: 1rem;
    padding-bottom: 1.25rem;

    .item {
      width: 33.33%;

      .icon {
        display: block;
        height: 3rem;
        margin: auto;
      }

      .desc {
        font-size: .7rem;
        color: #212732;
        text-align: center;
      }
    }
  }
}

.other_service_box {
  background-color: #fff;
  border-top: .5rem solid #f7f7fa;

  .title {
    padding: .75rem 1rem 0;
    font-size: .8rem;
    color: #535a64;
  }

  .list {
    display: flex;
    margin-left: 1rem;
    margin-top: 1rem;
    padding-bottom: 1.25rem;

    .item {
      display: flex;
      align-items: center;
      margin-right: 1.5rem;

      .icon {
        flex-shrink: 0;
        display: block;
        height: 2.5rem;
        margin: auto;
      }

      .desc {
        flex-shrink: 0;
        font-size: .7rem;
        color: #212732;
        margin-left: .75rem;
        text-align: center;
        white-space: nowrap;
      }
    }
  }
}

.call_box {
  padding: 1rem 1rem 8rem;
  background-color: #f7f7fa;

  .list {
    border-radius: .3rem;
    background-color: #fff;
    padding: 1rem;
  }

  .call_item {
    display: flex;
    align-items: center;
    text-decoration: none;

    .icon {
      display: block;
      width: 1.85rem;
      height: 1.85rem;
    }

    .info {
      flex-grow: 1;

      .ttl {
        font-size: .8rem;
        color: #535a64;
        font-weight: bold;
        line-height: 1.5;
      }

      .tel {
        font-size: .7rem;
        color: #858b96;
        line-height: 1.5;
      }
    }
  }
}
</style>
